import { Component, Inject } from '@angular/core';
import { ActivecartePComponent } from '../../../views/history/activecarte-p/activecarte-p.component';
import { RSAHelperService } from 'src/app/services/rsahelper.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HistoriqueService } from 'src/app/services/historique.service';
import { ToastrService } from 'ngx-toastr';
import { User } from '../../user.model';


@Component({
  selector: 'app-updatepicture',
  templateUrl: './updatepicture.component.html',
  styleUrls: ['./updatepicture.component.scss']
})
export class UpdatepictureComponent {


  constructor(
    public dialogRef: MatDialogRef<UpdatepictureComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private historiqueService:HistoriqueService
    ,private rSAHelperService: RSAHelperService,private toastr: ToastrService){}
  
   ActualUser: string = "";
  details1:any;
  loading:boolean=true;
  codeR : boolean=false;
  imagePreview: string | ArrayBuffer;
  submitted = true;
  logo: any;
  user : User ;
  image:string;
  blocked=false
  ngOnInit(): void {
    // this.historiqueService.getHolderDetailsById(this.data).subscribe((res:any)=>{
    //   this.loading=false;
    //   this.details=res.xSubscriberCardsInfoListDetails;
  // console.log('tesssssst',this.data);
   this.user = JSON.parse(localStorage.getItem('subscriber'))
   //this.image = this.user['param5'];
   //this.image= localStorage.getItem('picture')
   this.imagePreview ='data:image/png;base64,'+ localStorage.getItem('picture');
  
   this.ActualUser =localStorage.getItem('role');

    // })
  }


  fileChange(event) { 
    //console.log("event", event)
  let file = event.target.files[0];
  let reader = new FileReader(); 
  reader.readAsDataURL(file); 
  reader.onload = () => { 
    this.imagePreview = reader.result; 
    //console.log("this.imagePreview123",this.imagePreview)
  }
  
  }
  fermer(){
    this.dialogRef.close()
  }
  update(){
    

    this.submitted = true;
    this.user = JSON.parse(localStorage.getItem('subscriber'))
    this.logo =this.imagePreview;
  //console.log("logooooooooooo",this.logo);
  
    var model = {
      'identifiant':this.data.identifiant,
      "etablissementCode": "00606",
      "canalCode": "03",
      "typeUser": '',
      "picture": this.logo.split(",")[1],
      //"numCard":this.details1[0].param1
      
    }
   // console.log(model);
    
    const options= { positionClass:'toast-top-right' };
    this.historiqueService.updatephoto(model).subscribe((res:any)=>{
     // console.log(res.resultCode);
    
     
      if(res.resultCode==0)
      {
       

        this.codeR=true;
       
       // this.user['param5']=this.logo.split(",")[1]
       // console.log('  this.userpecture', this.user['param5']);
        
      this.toastr.success('photo a été changé avec succée','success',options)
     
      
      this.dialogRef.close(res.picture);
      //console.log("updatepictureee",res.picture);
      
      }
      else this.toastr.warning('Echec de modifier la photo du profil !')
    },
    (err)=>{
      this.toastr.error('Il faut choisir une nouvelle poto !')
    }
    )
  }
  





 
  
}